var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack503({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.08,11.26l1.06-.13a1,1,0,0,0,.27.63A.76.76,0,0,0,8,12a.73.73,0,0,0,.57-.26A1,1,0,0,0,8.76,11a.93.93,0,0,0-.23-.66A.71.71,0,0,0,8,10.12a2.05,2.05,0,0,0-.5.08l.12-.89a1,1,0,0,0,.68-.2.69.69,0,0,0,.23-.54.64.64,0,0,0-.17-.46.61.61,0,0,0-.46-.17.66.66,0,0,0-.48.19.94.94,0,0,0-.24.57l-1-.17a2.12,2.12,0,0,1,.32-.83,1.43,1.43,0,0,1,.59-.49A2,2,0,0,1,7.92,7a1.68,1.68,0,0,1,1.3.52A1.3,1.3,0,0,1,8.8,9.7a1.33,1.33,0,0,1,.79.48,1.39,1.39,0,0,1,.29.88,1.7,1.7,0,0,1-.55,1.29A1.91,1.91,0,0,1,8,12.88a1.88,1.88,0,0,1-1.29-.45A1.73,1.73,0,0,1,6.08,11.26Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack503);
export default __webpack_public_path__ + "static/media/Symbolpack_5_03.2db92b1475482b0bd3c956282d8f590e.svg";
export { ForwardRef as ReactComponent };